<template>
    <div class="hidden" v-if="!registered">
        <slot :categories="categories" />
    </div>
</template>

<script setup lang="ts">
import { inject, provide, Ref, ref, useSlots } from 'vue';
import { filterItems } from '@/utils';
import { OverviewCategory, OverviewFilter } from '@/types';

const props = defineProps<OverviewFilter>();

const slots = useSlots();

const categories: Ref<OverviewCategory[]> = ref([]);
const registered = ref(false);

const registerOverviewFilter =
    inject<(filter: OverviewFilter) => undefined>('registerOverviewFilter');

provide('registerOverviewCategory', registerCategory);

function registerCategory(category: OverviewCategory) {
    categories.value.push(category);
    if (slots.default().filter(filterItems).length === categories.value.length) {
        registered.value = true;
        registerOverviewFilter({ ...props, categories: categories.value });
    }
}
</script>
